import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslocoService,TranslocoModule } from "@ngneat/transloco";

@Component({
  selector: 'angular-community-language-menu',
  standalone: true,
  imports: [CommonModule, FormsModule,MatIconModule, MatButtonModule, MatMenuModule, TranslocoModule],
  templateUrl: './language-menu.component.html',
  styleUrls: ['./language-menu.component.scss'],
})
export class LanguageMenuComponent implements OnInit {
  constructor(@Inject(DOCUMENT) private document: Document, 
  private translocoService: TranslocoService) {}

  ngOnInit(): void {}

  setLanguage(menuItem : any){
    this.translocoService.setActiveLang(menuItem.srcElement.value.toString());

   
}
}